export default __webpack_public_path__ + "static/spark_add_account2-38081483b5c7683ae8d682bde2f08f98.png";